export default __webpack_public_path__ + "static/media/promo-zapier.93cac8a4.png";